import { Color } from 'libs/shared/src/models';
import { GsFormField, GsFormFieldColor, GsFormIf } from '../../../components';

const BG_COLOR_TRANSLATION = 'schema.colors.backgroundColor';
const TEXT_COLOR_TRANSLATION = 'schema.colors.textColor';

export function colorGeneratorSchema(
  formControlName?: string,
  label?: string,
  defaultValue?: Color,
  ifArgs?: GsFormIf,
  groupingName?: string
): GsFormField<never>[] {
  return [
    ...colorBackgroundGeneratorSchema(formControlName, label, defaultValue, ifArgs, groupingName),
    ...colorTextGeneratorSchema(formControlName, label, defaultValue, ifArgs, groupingName)
  ] as GsFormField<never>[];
}

export function colorBackgroundGeneratorSchema(
  formControlName?: string,
  label?: string,
  defaultValue: Color = 'primary-main',
  ifArgs?: GsFormIf,
  groupingName?: string
): GsFormField<never>[] {
  return [
    {
      formControlName: formControlName ? formControlName + 'BackgroundColor' : 'backgroundColor',
      label: label ? `${label}` : BG_COLOR_TRANSLATION,
      type: 'color',
      default: defaultValue,
      if: ifArgs,
      groupingName: groupingName
    } as GsFormFieldColor
  ];
}

export function colorTextGeneratorSchema(
  formControlName?: string,
  label?: string,
  defaultValue: Color = 'primary-contrast',
  ifArgs?: GsFormIf,
  groupingName?: string
): GsFormField<never>[] {
  return [
    {
      formControlName: formControlName ? formControlName + 'TextColor' : 'textColor',
      label: label ? `${label}` : TEXT_COLOR_TRANSLATION,
      type: 'color',
      default: defaultValue,
      if: ifArgs,
      groupingName: groupingName
    } as GsFormFieldColor
  ];
}
